import { Divider, Stack } from "@mui/material";
import { useFormContext, useWatch } from "react-hook-form";
import PhotoUploader from "./PhotoUploader";
import { ChoiceField, SellingField, StepHeading } from "./FormFields";
import type { LocalPhoto, SellingValues } from "./types";

export default function PhotosConditionStep({
  photos,
  onPhotos,
  onBusy,
  photoError,
}: {
  photos: LocalPhoto[];
  onPhotos: (photos: LocalPhoto[]) => void;
  onBusy: (busy: boolean) => void;
  photoError?: string;
}) {
  const { control, setValue } = useFormContext<SellingValues>();
  const condition = useWatch({ control, name: "condition" });
  return (
    <>
      <StepHeading title="Show Off Your Toy">
        Clear photos and honest details help collectors buy with confidence.
      </StepHeading>
      <Stack spacing={3}>
        <PhotoUploader
          photos={photos}
          onChange={onPhotos}
          onBusy={onBusy}
          validationError={photoError}
        />
        <Divider />
        <ChoiceField
          name="condition"
          label="What Condition Is It In?"
          options={[
            {
              value: "new",
              label: "New",
              detail: "Unused, with its original condition intact.",
            },
            {
              value: "used",
              label: "Used",
              detail: "Previously owned, played with, or displayed.",
            },
          ]}
          onChange={(value) => {
            if (value === "used")
              setValue("quantity", "1", {
                shouldDirty: true,
                shouldValidate: true,
              });
          }}
        />
        <SellingField
          name="quantity"
          label="How Many Do You Have?"
          required
          numeric
          disabled={condition === "used"}
          helper={
            condition === "used"
              ? "Used toys are limited to one so each listing represents the toy shown."
              : "Enter the number of identical new toys available."
          }
        />
        <SellingField
          name="conditionNotes"
          label="Condition details (optional)"
          maxLength={1000}
          multiline
          helper="Mention wear, missing parts, damage, or packaging condition. No grading expertise needed."
        />
      </Stack>
    </>
  );
}
